const IsoDownload = ({ color }: { color?: string }): JSX.Element => {
  const className = 'icon icon--isodownload';
  color = color || '#2E7CF6';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="18"
      viewBox="0 0 14 18"
      fill="none"
      {...{ className }}
    >
      <path
        d="M6.97203 11.7555C7.21145 11.7555 7.41452 11.5511 7.41452 11.3012V3.14578L7.38554 2.0478L8.03117 2.74445L9.26455 4.08475C9.34434 4.17562 9.4604 4.22105 9.56923 4.22105C9.79412 4.22105 9.97551 4.04689 9.97551 3.81214C9.97551 3.68342 9.92471 3.59255 9.84493 3.50168L7.29123 0.896807C7.1824 0.783223 7.08809 0.745361 6.97203 0.745361C6.8559 0.745361 6.76159 0.783223 6.65282 0.896807L4.0991 3.50168C4.01204 3.59255 3.96126 3.68342 3.96126 3.81214C3.96126 4.04689 4.13538 4.22105 4.36753 4.22105C4.47635 4.22105 4.59968 4.17562 4.67949 4.08475L5.91281 2.74445L6.55852 2.0478L6.52947 3.14578V11.3012C6.52947 11.5511 6.73261 11.7555 6.97203 11.7555ZM2.79324 17.5862H11.1435C12.5582 17.5862 13.2837 16.829 13.2837 15.375V7.63616C13.2837 6.1747 12.5582 5.41747 11.1435 5.41747H9.07586V6.35644H11.1217C11.927 6.35644 12.3841 6.81077 12.3841 7.68159V15.3221C12.3841 16.2004 11.927 16.6472 11.1217 16.6472H2.80775C1.99521 16.6472 1.55267 16.2004 1.55267 15.3221V7.68159C1.55267 6.81077 1.99521 6.35644 2.80775 6.35644H4.86811V5.41747H2.79324C1.37856 5.41747 0.653076 6.16713 0.653076 7.63616V15.375C0.653076 16.8365 1.37856 17.5862 2.79324 17.5862Z"
        fill={color}
      />
    </svg>
  );
};

export default IsoDownload;
